import {useState, useMemo} from 'react';
import {DragEndEvent, DragStartEvent, PointerSensor, useSensor, useSensors} from '@dnd-kit/core';
import {getHourMinutes} from '../../../library/dates';
import {TTimetableItem} from '../../../redux/timetable/timetable.type';
import {moveLecture} from '../../../redux/timetable/timetableActions';

const formatTime = (timestamp: number) => getHourMinutes(timestamp);

export function useDragLecture(lectures: TTimetableItem[]) {
    const [activeId, setActiveId] = useState<number | null>(null);

    const sensors = useSensors(
        useSensor(PointerSensor, {activationConstraint: {distance: 8}})
    );

    const activeLecture = useMemo(
        () => activeId ? lectures.find(l => l.ttid === activeId) ?? null : null,
        [activeId, lectures]
    );

    const handleDragStart = ({active}: DragStartEvent) => setActiveId(Number(active.id));

    const handleDragEnd = ({active, over}: DragEndEvent) => {
        setActiveId(null);
        if(!over) return;
        const ttid = Number(active.id);
        const lecture = lectures.find(l => l.ttid === ttid);
        if(!lecture) return;
        const overId = Number(over.id);
        const overLecture = lectures.find(l => l.ttid === overId);
        const newTime = overLecture ? overLecture.time : overId;
        if(formatTime(lecture.time) === formatTime(newTime)) return;
        moveLecture(ttid, newTime);
    };

    return {sensors, activeLecture, handleDragStart, handleDragEnd};
}
